module.exports = __webpack_public_path__ + "static/img/dzh2.0b27ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dzh2.png
// module id = cvHL
// module chunks = 2